import { ShareAltOutlined } from "@ant-design/icons";
import { Col, Row, Tooltip } from "antd";
import { showError } from "common/ToastNotifications";
import ShareDataObjectModalDialog from "components/organisms/ShareDataObjectModalDialog";
import moment from "moment";
import { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Action, Dispatch } from "redux";
import actions from "store/actions";
import AppState from "store/AppState";

const mapStateToProps = (state: AppState) => {
    return {
        getDataObjectSharedLinkResult: state.dataObjects.getDataObjectSharedLinkResult,
        dataObjectSharedLinkResult: state.dataObjects.dataObjectSharedLinkResult,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action<string>>) => {
    return {
        getDataObjectSharedLink: (businessAreaId: string, schemaId: string, dataSetId: string, dataObjectId: string, expires: string, readOnly: boolean) =>
            dispatch(actions.getDataObjectSharedLinkRequest(businessAreaId, schemaId, dataSetId, dataObjectId, expires, readOnly)),
    };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type IPropsFromRedux = ConnectedProps<typeof connector>;

interface IDataObjectShareOptionProps extends IPropsFromRedux {
    businessAreaId: string;
    schemaId: string;
    dataSetId: string;
    dataObjectId: string;
    children: React.ReactNode;
    getDataObjectSharedLink: (businessAreaId: string, schemaId: string, dataSetId: string, dataObjectId: string, expiryDate: string, readOnly: boolean) => void;
}

type IDataObjectShareOptionStates = {
    showShareModalDialog: boolean;
    gettingLink: boolean;
    shareLink: string | null;
};

class DataObjectShareOption extends Component<IDataObjectShareOptionProps & RouteComponentProps, IDataObjectShareOptionStates> {
    constructor(props: IDataObjectShareOptionProps & RouteComponentProps) {
        super(props);
        this.state = {
            showShareModalDialog: false,
            gettingLink: false,
            shareLink: null,
        };
    }

    componentWillMount() {}

    componentDidMount() {}

    componentDidUpdate(prevProps: IDataObjectShareOptionProps & RouteComponentProps, prevState: unknown, snapshot: unknown) {
        this.onGetDataObjectSharedLinkResultChanged(prevProps);
    }

    onGetDataObjectSharedLinkResultChanged = (prevProps: IDataObjectShareOptionProps & RouteComponentProps) => {
        if (this.props.getDataObjectSharedLinkResult && this.props.getDataObjectSharedLinkResult !== prevProps.getDataObjectSharedLinkResult) {
            if (!this.props.getDataObjectSharedLinkResult.success) {
                showError("Could not able to get share link.");
            } else {
                if (this.props.dataObjectSharedLinkResult) {
                    this.setState({
                        shareLink: this.props.dataObjectSharedLinkResult.url,
                    });
                } else {
                    showError("Could not able to get share link.");
                }
            }
            this.setState({
                gettingLink: false,
            });
        }
    };

    onShareClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
        e.stopPropagation && e.stopPropagation();
        e.preventDefault && e.preventDefault();
        this.setState({ showShareModalDialog: true, shareLink: null });
    };

    onGetLink = ({ readOnly, expiryDate }: { readOnly: boolean; expiryDate: moment.Moment }) => {
        if (this.state.gettingLink) {
            return;
        }
        this.setState({
            gettingLink: true,
        });
        this.props.getDataObjectSharedLink(
            this.props.businessAreaId,
            this.props.schemaId,
            this.props.dataSetId,
            this.props.dataObjectId,
            expiryDate ? expiryDate.utc().format("YYYYMMDDHHmmss") : moment().add(5, "minutes").utc().format("YYYYMMDDHHmmss"),
            readOnly,
        );
    };

    onClose = () => {
        this.setState({
            shareLink: null,
            showShareModalDialog: false,
        });
    };

    render() {
        return (
            <>
                <ShareDataObjectModalDialog
                    show={this.state.showShareModalDialog}
                    onGetLink={this.onGetLink}
                    loading={this.state.gettingLink}
                    shareLink={this.state.shareLink}
                    onClose={this.onClose}
                ></ShareDataObjectModalDialog>
                <Row>
                    <Col span={4}>
                        <Tooltip title={"Share link"}>
                            <ShareAltOutlined style={{ cursor: "pointer" }} onClick={this.onShareClick} />
                        </Tooltip>
                    </Col>
                    <Col span={20}>{this.props.children}</Col>
                </Row>
            </>
        );
    }
}

export default connector(withRouter(DataObjectShareOption));
